// The word on a stored notification's clearing button, stated once for the
// queue page and the deal panel (people-create-door T8d). Most kinds clear an
// FYI. pilot_form_differs does more: the resolved row IS David's Keep mine (the
// PHF sync reads it back and never flags that same form value again), so the
// button says what it records, and goes through the keep door (services/
// queue.service.js clearQueueNotification). Use the pilot's is the T8e handle
// beside it (components/queue/UsePilotValueButton.jsx).
const CLEAR_LABEL = { pilot_form_differs: 'Keep mine' };
const CLEAR_TITLE = { pilot_form_differs: 'Keep the record\'s value; this same form value will not be flagged again' };

export function clearLabel(kind) { return CLEAR_LABEL[kind] || 'Clear'; }
export function clearTitle(kind) { return CLEAR_TITLE[kind] || 'Clear this notification'; }

// A queue source that failed or was cut is said on the broker's screen (Q13, David 2026-10-20), one
// plain label per source. services/queue.service.js names the sources; every one it can report has a
// label here (tests/queue-source-errors-line.test.js). An unknown source shows as written. The line
// clears, retries and hides nothing: it goes when a load reads clean.
export const SOURCE_LABEL = {
  notifications: 'Notices',
  detected_docs: 'Quote mail',
  triage_docs: 'Documents to sort',
  presented_quotes: 'Quotes presented',
  followups: 'Follow-ups',
  pipeline: 'Deal names and producer scope',
  bind_holds: 'Signing holds',
  person_suggestions: 'People suggestions',
  bind_request_flags: 'Bind requests with changes',
  paper_drafts: 'Paperwork drafts',
  draft_quotes: 'Draft quotes',
  markets: 'Markets',
  expiring_quotes: 'Expiring quotes',
  done_today: 'Done today',
  deferred_collections: 'Deferred payments',
  deferred_threshold: 'Deferred payment limit',
  unattached_paper_phfs: 'Paper pilot forms with no deal',
  unlanded_paper_submissions: 'Paper submissions not landed',
  phf_chase: 'Pilot forms to chase',
  unlinked_pilots: 'Pilots not linked',
  signed_app_link_review: 'Signed applications to review',
  imported_documents_to_name: 'Imported documents to name',
};
export const SOURCE_ERRORS_HEAD = 'Part of the queue could not be read, so it may be missing items:';
export const SOURCE_ERRORS_DETAILS = 'Details';
export const DEAL_QUEUE_PARTIAL = "Part of this deal's queue could not be read";

export function sourceLabel(source) {
  if (!source) return 'Unknown source';
  return Object.prototype.hasOwnProperty.call(SOURCE_LABEL, source) ? SOURCE_LABEL[source] : String(source);
}
export function cutLine(entry) {
  return `${sourceLabel(entry?.source)}: ${entry?.total_at_least ?? entry?.shown} or more open, only the first ${entry?.shown} shown`;
}
// The unreadable sources (one label each, in first-seen order) and the cut lines (one per cut entry).
export function splitSourceErrors(errors) {
  const unread = [];
  const cut = [];
  for (const e of Array.isArray(errors) ? errors : []) {
    if (e?.cut) cut.push(cutLine(e));
    else if (!unread.includes(sourceLabel(e?.source))) unread.push(sourceLabel(e?.source));
  }
  return { unread, cut };
}
